import angular from 'angular'
import routers from './routers.js'
import reportQueryCtrl from './reportQueryCtrl'

export default angular
  .module('declaration.vatDeclarationSurcharges.reportQuery', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('reportQueryCtrl', reportQueryCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/reportQuery/index.js